import { render, staticRenderFns } from "./adminCMS.vue?vue&type=template&id=71789dcc"
import script from "./adminCMS.vue?vue&type=script&lang=js"
export * from "./adminCMS.vue?vue&type=script&lang=js"
import style0 from "./adminCMS.vue?vue&type=style&index=0&id=71789dcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports